import { menuFirsts } from "../../constants/menu";
import ListPosition from "../../page/position/list/list";

const routePosition = [
    {
      ...menuFirsts.POSITION,
      key: menuFirsts.POSITION.key,
      name: menuFirsts.POSITION.name,
      code: menuFirsts.POSITION.code,
      textName: menuFirsts.POSITION.textName,
      active: false,
      appBar: true,
      component: ListPosition
    } ,
    
]

export default routePosition